import { ref, isRef, Ref } from 'vue'
import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from './queries-core'
export function useUserAccessTokensQueryV1(userId?: string | Ref<string>, ) {
	const _userId = isRef<string>(userId) ? userId : ref<string>(userId)
	const result = {
		userId: _userId,
		...useQuery(() => new q.UserAccessTokensQueryV1(_userId.value))
	}
	return {
		...result,
		runUserAccessTokensQueryV1: result.run,
		modelUserAccessTokensQueryV1: result.model,
	}
}

